import "./App.css";
import { useRef, useState } from "react";
import { useCountUp } from "react-countup";

function App() {
  const scoreRef = useRef(0);
  const totalRef = useRef(0);
  const historyRef = useRef([]);
  const [zeroScore, setZeroScore] = useState(true);

  const scoreCountUpRef = useRef(null);
  const scoreCountUp = useCountUp({ ref: scoreCountUpRef, duration: 0.4 });
  const totalCountUpRef = useRef(null);
  const totalCountUp = useCountUp({ ref: totalCountUpRef, duration: 0.4 });

  const saveState = () => {
    historyRef.current.push([scoreRef.current, totalRef.current]);
  };

  const setScore = (score) => {
    scoreRef.current = score;
    scoreCountUp.update(score);
    if ((score === 0) !== zeroScore) {
      setZeroScore(score === 0);
    }
  };

  const addScore = (score) => {
    saveState();
    setScore(scoreRef.current + score);
  };

  const resetScore = () => {
    saveState();
    setScore(0);
  };

  const setTotal = (total) => {
    totalRef.current = total;
    totalCountUp.update(total);
  };

  const bankScore = () => {
    saveState();
    setTotal(totalRef.current + scoreRef.current);
    setScore(0);
  };

  const undoMove = () => {
    if (historyRef.current.length > 0) {
      const [score, total] = historyRef.current.pop();
      setScore(score);
      setTotal(total);
    }
  };

  const resetGame = () => {
    saveState();
    setTotal(0);
    setScore(0);
  };

  return (
    <div id="app">
      <div className="button-row-2">
        <div className="label-and-counter">
          <div className="label">Total</div>
          <div className="counter" ref={totalCountUpRef} />
        </div>
        <div className="label-and-counter">
          <div className="label">Current</div>
          <div className="counter" ref={scoreCountUpRef} />
        </div>
      </div>

      <div id="button-grid">
        {[50, 100].map((n) => (
          <button key={`singledice-${n}`} onClick={() => addScore(n)}>
            {n}
          </button>
        ))}

        {[200, 300, 400, 500, 600, 1000].map((n) => (
          <div
            key={`multipledice-row-${n}`}
            className="button-row-with-multipliers"
          >
            <button onClick={() => addScore(n)}>{n}</button>
            <button onClick={() => addScore(n * 2)} className="small-text">
              x2
            </button>
            <button onClick={() => addScore(n * 4)} className="small-text">
              x4
            </button>
            <button onClick={() => addScore(n * 8)} className="small-text">
              x8
            </button>
          </div>
        ))}

        {[750, 1500].map((n) => (
          <button key={`straight-${n}`} onClick={() => addScore(n)}>
            {n}
          </button>
        ))}

        <div className="button-row-3">
          <button onClick={undoMove}>Undo</button>
          <button onClick={bankScore}>Bank</button>
          {zeroScore ? (
            <button onClick={resetGame}>Reset</button>
          ) : (
            <button onClick={resetScore}>Bust</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
